var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "template-card-v2",
    {
      attrs: {
        "one-log": _vm.oneLog,
        linkedtype: _vm.linkedtype,
        linkedid: _vm.linkedid,
        "has-history": false
      }
    },
    [
      _c("template", { slot: "label" }, [_vm._v(_vm._s(_vm.oneLog.title))]),
      _vm._v(" "),
      _c("div", {
        staticClass: "pre-line",
        attrs: { slot: "content" },
        domProps: { innerHTML: _vm._s(_vm.oneLog.content) },
        slot: "content"
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }